import { StyledTextField } from './TextField.styles';
import * as React from 'react';

export interface TextFieldProps {
  /**
   * The value of the input element.
   */
  value: string;
  /**
   * The label and placeholder text.
   */
  label: string;
  /**
   * The id of the input element.
   */
  id: string;
  /**
   * If true, the label will be displayed in an error state.
   */
  error: boolean;
  /**
   * If true, the input element will be disabled.
   */
  disabled?: boolean;
  /**
   * Optional key press handler.
   */
  onKeyPress: (event: React.KeyboardEvent<HTMLElement>) => void;
  /**
   * Optional onChange handler.
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * Option testid
   */

  'data-testid'?: string;
}

/**
 * Allowing the user to enter a value in a form.
 */
export const TextField: React.FC<TextFieldProps> = ({
  value,
  disabled = false,
  label,
  error,
  ...props
}: TextFieldProps) => {
  return (
    <StyledTextField
      color="primary"
      disabled={disabled}
      label={label}
      margin="normal"
      error={error}
      value={value}
      variant="standard"
      fullWidth
      {...props}
    />
  );
};

export default TextField;
